import React from "react";
import { Paper, Typography, useTheme } from "@mui/material";
import { IconTitle, ArticleCustomIcon } from "../ui/UserIcons";

interface AboutSectionProps {
  description?: string;
}

const AboutSection: React.FC<AboutSectionProps> = ({ description }) => {
  const theme = useTheme();

  return (
    <Paper elevation={0} sx={{ p: 3, mb: 3 }}>
      <IconTitle
        Icon={ArticleCustomIcon}
        title="About"
        color={theme.palette.materiom.seaweed}
      />
      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ lineHeight: 1.7 }}
        >
          {description}
        </Typography>
      )}
    </Paper>
  );
};

export default AboutSection;
